import BaseService from '@/services/BaseService';

class EmailConfigService extends BaseService {
    getEmailConfig = () => this.get('/get-email-config');

    addEmailConfig = (data) => this.post('/add-email-config', data);
}

export default new EmailConfigService();
